// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_title__2Bksg","content":"modal_content__2NJN7","button":"modal_button__26dnY","modal_body":"modal_modal_body__tvXux"};